/**
 * Types of the application toasts.
 */
export enum ToastTypes {
    test = 'test',
}
